import React from "react";

import { HeroSection } from "./HeroSection";
import OurMissionSection from "./OurMission";
import JoinUs from "./JoinUs";
import StayConnected from "./StayConnected";

const Home = () => {
  return (
    <div>
      <HeroSection />
      <OurMissionSection />
      <JoinUs />
      <StayConnected />
    </div>
  );
};

export default Home;
